// components/ItineraryScreen.jsx
import React, { forwardRef } from 'react';
import ReactMarkdown from 'react-markdown';

const formatItinerary = (text) => {
  return text
    .trim()
    .replace(
      /(^|\r?\n)\s*---+\s*(?=\r?\n|$)/g,
      '$1<hr class="my-4 border-t-2 border-gray-300 opacity-50" />'
    )
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(
      /^#{1,6}\s*(.*)$/gim,
      '<h3 class="font-semibold text-lg mt-4 mb-2" style="break-inside:avoid;page-break-inside:avoid;">$1</h3>'
    )
    .replace(
      /^\s*[-*]\s+(.*)$/gm,
      '<li style="break-inside:avoid;page-break-inside:avoid;">$1</li>'
    )
    .replace(
      /(?:<li[\s\S]*?<\/li>)+/g,
      (m) => `<ul class="ml-6 list-disc mb-4">${m}</ul>`
    )
    .replace(
      /\n{2,}/g,
      '<p class="my-2" style="break-inside:avoid;page-break-inside:avoid;"></p>'
    )
    .replace(/\n/g, '<br />')
    .replace(/\*/g, '');
};

const ItineraryScreen = forwardRef(({ content, onDownload }, ref) => {
  const handleDownload = () => {
    const node = ref.current;
    if (node) {
      node.classList.add('-mt-16', 'pb-16');
    }
    onDownload();
    setTimeout(() => {
      if (node) {
        node.classList.remove('-mt-16', 'pb-16');
      }
    }, 1000);
  };

  return (
    <>
      <div
        ref={ref}
        className="
          flex-1
          px-6
          pb-6
          overflow-y-auto
          prose prose-sm max-w-none
          prose-headings:mt-0
          prose-p:mt-0
        "
        style={{
          breakInside: 'avoid',
          pageBreakInside: 'avoid',
          widows: 2,
          orphans: 2,
        }}
      >
        {/* Markdown Rendering for better formatting */}
        <ReactMarkdown
          components={{
            table: ({ children }) => (
              <table className="table-auto border-collapse border border-gray-300">{children}</table>
            ),
            th: ({ children }) => (
              <th className="border border-gray-300 px-2 py-1 bg-gray-100">{children}</th>
            ),
            td: ({ children }) => (
              <td className="border border-gray-300 px-2 py-1">{children}</td>
            ),
          }}
        >
          {content}
        </ReactMarkdown>

        {/* Fallback for PDF formatting using dangerous HTML */}
        <div
          className="hidden print:block"
          dangerouslySetInnerHTML={{ __html: formatItinerary(content) }}
        />
      </div>

    </>
  );
});

export default ItineraryScreen;
